import {useCallback, useMemo, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DeleteItemsApi } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { TABLES } from '../../../../../Apis/Tables';
import { permissionObj } from '../../../../../Helpers/permission';
import { WorkShiftRenderDetails } from '../Subcomponents/WorkShiftRenderDetails';
import { UpdateIconsOptions } from '../../../../../components/buttons/IconButtons';
import { SimpleSearch } from '../../../../../reduxToolkit/Search/SearchApi';
import routes from '../../../../../Routes/routes';
import DropDownMenuProfile from './../../../../../components/DropDown/DropDownMenuProfile';
import DropDownMenuItem from './../../../../../components/DropDown/DropDownMenuItem';
import TableFunction from './../../../../../components/table/TableFunction';
import { SEARCH_MODEL } from '../../../../../components/table/Model/TableModel';
import {errorMsg} from "../../../../../Apis/functions";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const WorkshiftFunctionality = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const permission = useSelector((state) => state.authenticatioauthennSlice.permission);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const [contractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId] = useState(sessionStorage.getItem('providerId'));
    const [search, setSearch] = useState(false);
    const [simpleSearch, setSimpleSearch] = useState(false);
    const [deleteShow, setDeleteShow] = useState(false);
    const [modified, setModified] = useState(false);
    const [selectedList, setSelectedList] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false);
    const [resultsToShow, setResultsToShow] = useState('');
    const [searchElement, setSearchElement] = useState('');
    const [bodyForExport, setBodyForExport] = useState();
    //modal titles and options
    const title_modal = `work_shift_panel`;
    const element_modal = `workshift`;
    const option = TABLES.WORKSHIFT;

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = (page) => {
        const body = SEARCH_MODEL.setObject({ page, size: rowsPerPage, key: searchElement, model: option });
        dispatch(SimpleSearch({ body })).then(
            ({
                 payload: {
                     data: { data, success },
                 },
             }) => {
                if (success) {
                    setResultsToShow(data);
                }
            },
        );
    }

    const {
        handleClose,
        handleCheckboxChange,
        handleDeleteAll,
        pagination,
        rowsPerPage,
        openMenu,
        handleMenuToggle,
    } = TableFunction({
        fixed: false,
        selectedList,
        setSelectedList,
        setIsAllChecked,
        data: resultsToShow,
        labelRowsPerPage: 'workshif_per_page',

        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    // Deletes the selected work shifts
    const deleteWorkShift = () => {
        dispatch(DeleteItemsApi({ tableName: option, body: selectedList })).then(
            ({
                payload: {
                    data: { success, code},
                },
            }) => {
                if (success) {
                    setSelectedList([]);
                    setIsAllChecked(false);
                    setModified(true);
                }else errorMsg(code);
            },
        );
    };

    const columns = useMemo(
        () => [{ field: 'name', label: 'name' }],
        []
    );

    const renderExpandedRow = useCallback(
        (row) => {
            return <WorkShiftRenderDetails row={row.row} />;
        },
        [],
    );

    // Navigate to the create work shift flow.
    const handleCreate = () => navigate(routes.workshift.create);

    const renderOptionsMenu = (row, index) => {
        return (
            <div onClick={(e) => e.stopPropagation()}>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${row.id}`}>
                    {(DEV || permission?.includes(permissionObj?.WEB_WORK_SHIFT_UPDATE)) && (
                        <DropDownMenuItem
                            index={index}
                            handleClose={handleClose}
                            name={t('update')}
                            click={() => navigate(`${routes.workshift.update}/${row.id}`)}
                            icon={<UpdateIconsOptions />}
                        />
                    )}
                </DropDownMenuProfile>
            </div>
        );
    };

    const handleRowExpand = (row) => {};

    return {
        t,
        DEV,
        permission,
        deleteShow,
        setDeleteShow,
        setModified,
        selectedList,
        setSelectedList,
        setIsAllChecked,
        handleDeleteAll,
        handleCheckboxChange,
        deleteWorkShift,
        title_modal,
        element_modal,
        option,
        contractorId,
        supplierId,
        setSearch,
        simpleSearch,
        setSimpleSearch,
        searchElement,
        setSearchElement,
        pagination,
        setResultsToShow,
        resultsToShow,
        columns,
        renderExpandedRow,
        renderOptionsMenu,
        handleRowExpand,
        rowsPerPage,
        setBodyForExport,
        handleCreate,
    };
};

export default WorkshiftFunctionality;
